<template>
  <div ref="containerRef" class="seccion-rasgada">
    <!-- SVG MASK INTERNO: Trazado orgánico y delicado -->
    <svg width="0" height="0" class="svg-mask-element">
      <defs>
        <mask id="paper-mask-subtle" maskUnits="objectBoundingBox" maskContentUnits="objectBoundingBox">
          <path
            d="M 0,0.015 
               C 0.1,0.008 0.2,0.02 0.35,0.01 
               C 0.5,0.02 0.65,0.008 0.8,0.015 
               C 0.9,0.008 0.95,0.015 1,0.012 
               L 1,0.988 
               C 0.88,0.992 0.75,0.982 0.6,0.99 
               C 0.45,0.982 0.3,0.992 0.15,0.985 
               C 0.08,0.99 0.03,0.985 0,0.988 Z"
            fill="#ffffff"
          />
        </mask>
      </defs>
    </svg>

    <div class="contenido-fotos">
      <!-- FOTO 1: Revelado Sutil con Enfoque Sedoso (Silk Unblur) -->
      <div class="reveal-container rev-1">
        <div class="foto-wrapper" ref="foto1Ref">
          <img
            src="@/assets/IMG_4307_11zon.webp"
            alt="Foto principal"
            class="foto-elegante"
          />
        </div>
      </div>

      <!-- FOTO 2: Flotación Cinematográfica (Soft Float & Focus) -->
      <div class="reveal-container rev-2">
        <div class="foto-wrapper" ref="foto2Ref">
          <img
            src="@/assets/IMG_4270_11zon.webp"
            alt="Foto secundaria"
            class="foto-elegante"
          />
        </div>
      </div>

     
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionEleganteLenta',
  setup() {
    const containerRef = ref(null)
    const foto1Ref = ref(null)
    const foto2Ref = ref(null)
    const foto3Ref = ref(null) // Referencia para la tercera foto
    let ctx = null

    onMounted(() => {
      ctx = gsap.context(() => {
        // ------------------------------------
        // FOTO 1: Revelado pausado estilo seda
        // ------------------------------------
        const tl1 = gsap.timeline({
          scrollTrigger: {
            trigger: '.rev-1',
            start: 'top 90%', // Comienza con calma al asomar
            toggleActions: 'play none none none',
            once: true
          }
        })

        // La máscara se desplaza despacio (2.2 segundos)
        tl1.fromTo('.rev-1',
          { clipPath: 'inset(100% 0% 0% 0%)' },
          { 
            clipPath: 'inset(0% 0% 0% 0%)', 
            duration: 2.2, 
            ease: 'power2.inOut' 
          }
        )
        // La foto interna pierde un micro-blur (3px a 0px) y baja levemente de escala
        .fromTo(foto1Ref.value,
          { scale: 1.08, filter: 'blur(3px)', opacity: 0.4 },
          { 
            scale: 1, 
            filter: 'blur(0px)', 
            opacity: 1,
            duration: 2.4, 
            ease: 'power1.out' 
          },
          '-=1.9' // Se entrelaza para que se sienta un solo movimiento continuo
        )

        // ------------------------------------
        // FOTO 2: Elevación suave y ligera inclinación 3D
        // ------------------------------------
        gsap.fromTo(foto2Ref.value,
          {
            y: 35,
            opacity: 0,
            rotationX: 6,      // Inclinación 3D imperceptible y elegante
            scale: 0.97,
            filter: 'blur(4px)' // Micro desenfoque inicial
          },
          {
            y: 0,
            opacity: 1,
            rotationX: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: 2.5,     // Transición ultra pausada
            ease: 'power1.out',
            scrollTrigger: {
              trigger: '.rev-2',
              start: 'top 80%', // Se dispara de forma independiente al bajar más
              toggleActions: 'play none none none',
              once: true
            }
          }
        )

        // ------------------------------------
        // FOTO 3: Deslizamiento lateral suave y desvanecimiento
        // ------------------------------------
        gsap.fromTo(foto3Ref.value,
          {
            x: -50, // Comienza desplazada a la izquierda
            opacity: 0,
            filter: 'blur(5px)' // Micro desenfoque inicial un poco más fuerte
          },
          {
            x: 0,
            opacity: 1,
            filter: 'blur(0px)',
            duration: 2.8,     // Transición aún más pausada
            ease: 'power2.out', // Facilidad de salida suave
            scrollTrigger: {
              trigger: '.rev-3',
              start: 'top 75%', // Se dispara un poco más tarde que la segunda
              toggleActions: 'play none none none',
              once: true
            }
          }
        )

      }, containerRef.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      containerRef,
      foto1Ref,
      foto2Ref,
      foto3Ref // Retornar la referencia para usarla en el template
    }
  }
}
</script>

<style scoped>
.seccion-rasgada {
  position: relative;
  background-color: #efb6c8;
  width: 100%;
  padding: 100px 20px;
  display: flex;
  margin-top: -40px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;

  /* Máscara de papel sutil */
  mask: url(#paper-mask-subtle);
  -webkit-mask: url(#paper-mask-subtle);
  mask-size: 100% 100%;
  -webkit-mask-size: 100% 100%;
}

.svg-mask-element {
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: none;
}

.contenido-fotos {
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  gap: 70px; /* Suficiente separación para que cada foto tenga su momento */
  z-index: 2;
  perspective: 1000px;
}

.reveal-container {
  width: 100%;
  overflow: hidden;
  will-change: clip-path, transform, opacity, filter; /* Añadir x e y a will-change si es necesario */
}

.foto-wrapper {
  width: 100%;
  border-radius: 3px;
  overflow: hidden;
  /* Sombra difusa y tenue para mantener la sofisticación */
  box-shadow: 0 15px 35px -10px rgba(0, 0, 0, 0.09);
  backface-visibility: hidden;
  transform-style: preserve-3d;
}

.foto-elegante {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  will-change: transform, opacity, filter;
  transform: translateZ(0);
}
</style>